import { ToastContainer , BackLink } from "../../components/Common";
import UserProfileFormPage from "./page";

const UserProfileFormWrapper = () => {
    //meta title
    document.title = "Profile Edit";

    return (
        <div className="page-content">
            <BackLink />
            <UserProfileFormPage />
            <ToastContainer/>
        </div>
    );
};

export default UserProfileFormWrapper;
